import { LibraryAPI } from '@business/api/library';
import { tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { CompactLibraryItemResponse } from '@business/entities/library';
import { FlowChartBlockVariation } from './FlowChartBlock';

export class FlowChartBlockBloc extends BaseBloc {
  constructor(private variation: FlowChartBlockVariation) {
    super();
  }

  items$ = new BehaviorSubject<CompactLibraryItemResponse[] | null>(null);
  readonly loading = new LoadingState({ loading: false });

  onInit() {
    return LibraryAPI.getLibraryItems(this.variation).pipe(tap(data => this.items$.next(data)));
  }
}
